<template>
	<div>
		<div class="flex flex-wrap">
			<BaseInput ref="BaseInput.company.name" :required="true" class="w-full" :label="$t('company')" type="text" v-model="company.name" />
		</div>
		<PersonNameForm ref="PersonNameForm" v-model="company" :show-company="false" />
		<AddressInput v-model="company" />

		<div class="flex flex-wrap">
			<BaseInput
				ref="BaseInput.company.phone"
				:required="true"
				class="w-full md:w-1/2 pr-0 md:pr-2"
				:label="$t('phone')"
				v-model="company.phone"
				type="text"
				validationtype="phone"
			/>

			<BaseInput
				:required="true"
				ref="BaseInput.company.email"
				validationtype="email"
				class="w-full md:w-1/2 pl-0 md:pl-2"
				:label="$t('e_mail')"
				v-model="company.email"
				:error-message="$t('e_mail_not_valid')"
				type="text"
			/>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';
import AddressInput from '@/components/forms/AddressInput';
import LawyerOfficeApplicationRepository from '@/api/repositories/LawyerOfficeApplicationRepository';
import Authentication from '@/mixins/Authentication';
import PersonNameForm from '@/components/forms/PersonNameForm.vue';

export default {
	name: 'ApplyLawyerOffice',
	components: { PersonNameForm, AddressInput, BaseInput },
	mixins: [Validate, Authentication],
	data() {
		return {
			company: {
				city: {},
			},
		};
	},
	mounted() {
		if (!this.isUserAllowedInLevel5or6) {
			this.$emit('authNotAllowed');
		}
	},
	methods: {
		save() {
			if (!this.validate()) {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				return;
			}
			this.$store.commit('setConfirmLeaving', false);

			LawyerOfficeApplicationRepository.store(this.company).then(() => {
				this.$swal(this.$t('general.success').toString(), this.$t('request_applied_system_message').toString(), 'success').then(() => {
					this.$store.dispatch('updateLawyerOfficeApplications');
					this.$router.replace({ name: 'repair_shop.service_provider' });
				});
			});
		},
	},
};
</script>
